/**
 * Build a filesystem/URL-safe File for S3 upload.
 * Drops spaces, parentheses (e.g. "photo (1).png"), and other unsafe chars
 * that break previews on staging CDNs while often working locally.
 */
export function renameFileForUpload(file, fallbackBase = "file") {
  if (!file || !(file instanceof Blob)) return file;

  const original = String(file.name || fallbackBase);
  const lastDot = original.lastIndexOf(".");
  const extRaw = lastDot >= 0 ? original.slice(lastDot + 1) : "";
  const ext = extRaw.toLowerCase().replace(/[^a-z0-9]/g, "");
  const id = `${Date.now()}-${Math.floor(Math.random() * 1_000_000_000)}`;
  const newName = ext ? `${id}.${ext}` : id;

  return new File([file], newName, {
    type: file.type || "application/octet-stream",
    lastModified: file.lastModified ?? Date.now(),
  });
}
